import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { PlacesLink } from 'utils/link';
import { useError } from 'contexts/error';
import { BreadCrumbLink } from 'components/styles_components/link';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import { PaginateProvider } from 'contexts/paginate';
import { WhiteCard } from 'components/styles_components/card';
import { Box } from 'components/ui';
import PlaceQuery from 'queries/place/show';
import InspectionSubjectsContainer from 'components/inspection_subject/index_container';
import InspectionsContainer from 'components/inspection/index_container';
import ShowItem from 'components/place/show_item';
import BreadcrumbContainer from 'components/layout/breadcrumb_container';
import TabsContainer from 'components/layout/tabs_container';
import TopMenu from 'components/layout/top_menu';
import LoaderContainer from 'components/layout/loader_container';
import Container from 'components/layout/container';

const Place = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const setError = useError();
  const {
    data = {
      space: {
        overInspectionsLimit: false,
        adminRole: true,
      },
      place: {
        overdueInspections: [],
        incomingInspections: [],
      },
      initLoading: true,
    },
    loading,
    error,
    refetch,
  } = useQuery(PlaceQuery, {
    variables: { id },
    onError: () => {
      setError('error.place.show');
      navigate(PlacesLink());
    },
  });

  return (
    <Container>
      <TopMenu>
        <BreadcrumbContainer>
          <BreadCrumbLink to={PlacesLink()}>
            <FormattedMessage id="breadcrumb.place.index" />
          </BreadCrumbLink>
          <BreadCrumbTypography>{data.place.name}</BreadCrumbTypography>
        </BreadcrumbContainer>
      </TopMenu>
      <LoaderContainer
        loading={loading}
        error={error}
        wrap={false}
        keepRenderedContent={!data.initLoading}
      >
        <ShowItem place={data.place} space={data.space} refetch={refetch} />
      </LoaderContainer>
      <Box sx={{ mt: 2 }}>
        <LoaderContainer wrap={false} loading={data.initLoading}>
          <WhiteCard>
            <TabsContainer
              tabs={[
                { key: 'inspections', label: <FormattedMessage id="inspection.count" />, visible: true },
                { key: 'inspection_subjects', label: <FormattedMessage id="inspection_subject.count" />, visible: true },
              ]}
              content={[
                <PaginateProvider key="place_inspections_content">
                  <InspectionsContainer showTitle={false} placeId={id} />
                </PaginateProvider>,
                <PaginateProvider key="inspection_subjects_content">
                  <InspectionSubjectsContainer showTitle={false} placeId={id} />
                </PaginateProvider>,
              ]}
            />
          </WhiteCard>
        </LoaderContainer>
      </Box>
    </Container>
  );
};

export default Place;
